<div class="cm-starting-icons-container">
    <div class="cm-hand">
        <i class="fas fa-arrow-left cm-arrows"></i>
        <i class="far fa-hand-back-point-up cm-hand-icon"></i>
        <i class="fas fa-arrow-right cm-arrows"></i>
    </div>
    <div class="cm-title">Drag to Rotate</div>
</div>
